module.exports = __webpack_public_path__ + "img/Korean Meal-Pork.19786389.jpg";